import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box,
    Button,
    DialogProps,
    Typography,
    TextField,
    MenuItem,
    FormHelperText,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, {useEffect, useState} from 'react';
import {COMMODITY_TYPES} from './commodityTypes';

type NomenclatureCommodityTypePopupProps = {
    open: boolean;
    onClose: () => void;
    selectedCount: number;
    handleSetCommodityTypeSelected: (commodityType: number | null) => Promise<void>;
} & Pick<DialogProps, 'fullWidth' | 'maxWidth'>;

export const NomenclatureCommodityTypePopup: React.FC<NomenclatureCommodityTypePopupProps> = ({
    open,
    onClose,
    fullWidth = true,
    maxWidth = 'sm',
    selectedCount,
    handleSetCommodityTypeSelected,
}) => {
    const [commodityType, setCommodityType] = useState<number | null>(0);

    useEffect(() => {
        if (!open) setCommodityType(0);
    }, [open]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth={fullWidth} maxWidth={maxWidth}>
            <Box sx={{p: '20px 24px 10px 3px', position: 'relative', backgroundColor: '#f5f7ff'}}>
                <DialogTitle sx={{pr: 5}}>Тип позиции</DialogTitle>
                <IconButton onClick={onClose} sx={{position: 'absolute', right: 16, top: 16}}>
                    <CloseIcon />
                </IconButton>
            </Box>

            <DialogContent>
                <Box display="flex" flexDirection="column" gap={2} pb={1}>
                    <Typography variant="subtitle1" fontWeight={600}>
                        Выберите тип для выделенных позиций ({selectedCount})
                    </Typography>

                    <TextField
                        select
                        size="small"
                        value={commodityType ?? ''}
                        onChange={e => setCommodityType(e.target.value === '' ? null : Number(e.target.value))}
                        sx={{backgroundColor: '#fff'}}
                    >
                        <MenuItem value="">Не задано</MenuItem>
                        {COMMODITY_TYPES.map(type => (
                            <MenuItem key={type.id} value={type.id}>
                                {type.name}
                            </MenuItem>
                        ))}
                    </TextField>
                    <FormHelperText>Тип печатается в&nbsp;чеке. Для позиций без типа касса печатает &laquo;Товар&raquo;.</FormHelperText>
                </Box>
                <Box sx={{mt: 2, mb: 1}}>
                    <Button
                        variant="contained"
                        onClick={() => {
                            onClose();
                            void handleSetCommodityTypeSelected(commodityType);
                        }}
                        sx={{mr: 2}}
                    >
                        Применить
                    </Button>
                    <Button variant="text" onClick={onClose}>
                        Отмена
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
};
